import React from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { getPathLanguage } from '../../../../utils/params';
import { Subtract } from 'assets/images/web-isn';

const BreadcrumbForOwners = props => {
  const pathLanguage = getPathLanguage(useLocation());
  return (
    <div className="section-block section-breadcrumb background-gray">
      <div className="container">
        <div className="row breadcrumb align-items-center px-0">
          <div className="col-12">
            <div className="breadcrumb-item row">
              <ul>
                {props.breadCrumb && props.breadCrumb.length
                  ? props.breadCrumb.map((item, index) => {
                      return (
                        <li key={index}>
                          {index === 0 ? (
                            <Link to={`${pathLanguage}${item.url}`}>{item.title}</Link>
                          ) : index === props.breadCrumb.length - 1 ? (
                            <>
                              <img className="mb-1" src={Subtract} alt="subtract" />
                              <span className="active">{item.title}</span>
                            </>
                          ) : (
                            <>
                              <img className="mb-1" src={Subtract} alt="subtract" />
                              <Link to={`${pathLanguage}${item.url}`}>{item.title}</Link>
                            </>
                          )}
                        </li>
                      );
                    })
                  : ''}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadcrumbForOwners;
